export const UIText = {
    copyright: "© 2022 Storytelling Connects. All Rights Reserved",
    siteContact: {
        name: "Simon Williams",
        email: "s.a.williams@sussex.ac.uk"
    },
    user: {
        first: 'Firstname',
        last: 'Lastname',
        email: 'Email',
        password: 'Password',
    },
    login: "Login",
    logOut: "Logout",
    loginForm: {
        email: 'Email',
        password: 'Password'
    },
    loginFeedbackOk: "Welcome!",
    loginFeedbackError: "Unfortunately, we were unable to process you login at this time; please try again later",
    register: "Register",
    registerDetails: "Complete the details below:",
    registerForm: {
        first: 'Firstname',
        last: 'Lastname',
        email: 'Email',
    },
    registerFeedbackOk: "Thank you for registering! Please check your email",
    registerFeedbackError: "Unfortunately, we were unable to process you registration at this time; please try again later",
    registerPassword: "Register Password",
    registerPasswordDetails: "Create your password below:",
    registerPasswordForm: {
        passwordFirst: 'Password',
        passwordSecond: 'Repeat Password',
    },
    registerPasswordFeedbackOk: "Thank you for registering! Please login using your email and password",
    registerPasswordFeedbackError: "Unfortunately, we were unable to process you registration at this time; please try again later",
    contact: "Contact",
    contactViaEmail: "You can contact us using email:",
    contactViaForm: "Or you can contact us using the form, below:",
    contactForm: {
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
    },
    contactFeedbackOk: "Thanks, your message has been received and sent on to the team",
    contactFeedbackError: "Unfortunately, we are unable to process you message at this time; please try again later",
    info: "For further information or to offer feedback on Storytelling Connects, please",
    feedbackHeading: "Questions or Feedback? We'd love to hear from you!",
    registerHeading: "Register or Login",
    registerInfo: "To access resources and training",
}

export const Success = {
    register: "Success! Please login using the information you just supplied"
}

export const Errors = {
    login: 'Failed to login - please contact someone at Storytelling Connects', 
    loginForm: {
        required: 'a value is required',
        email: 'a valid email is required',
        password: 'password is required',
    },
    registerForm: {
        required: 'a value is required',
        first: 'firstname is required',
        last: 'lastname is required',
        email: 'a valid email is required',
    },
    registerPasswordForm: {
        passwordFirst: 'password is required',
        passwordSecond: 'password is required',
        passwordMatch: 'the passwords do not match',
    },
    contactForm: {
        name: 'name is required',
        email: 'a valid email is required',
        subject: 'subject is required',
        message: 'message is required',
    },
    first: 'First name is required',
    last: 'Last name is required',
    email: 'Email is required',
    password: 'Password is required',
    passwordFormat: 'Password is required'
}